import apiCall from '../api/apiCall'
import pagination from '../pagination' 
import setLoadingState from './setLoadingState'
import errors from './errors'

export default {
    
  mixins: [apiCall, pagination, setLoadingState, errors],
  
  data() {
    return {
      initiated: false,
      loading: false,
      localProjects: [],
    }
  },

  methods: {
    loadLocalProjects(route) {
      
      this.resetErrors()
      this.setLoadingState(true)

      return new Promise((resolve, reject) => {
        this.apiCall(route)
          .then(({ data }) => {
            const { data: projects, pagination } = data;
            this.setPagination(pagination)
            this.setLocalProjects(projects)
            resolve(projects)
          })
          .catch((e) => { // we will probably need some error.message resolver based on what's coming from backend
            this.setErrors(e.message)
            reject(e)
          })
          .finally(() => {
            this.initiated = true
            this.setLoadingState(false)
          });
      })
    },

    reinitiate() {
      this.initiated = false
    },
    
    setLocalProjects(projects) {
      projects.forEach(p => this.localProjects.push(p))
    },

    resetLocalProjects() {
      this.localProjects = []
    },

    addLocalProject(project) {
      this.localProjects.push(project)
    },

    findLocalProject(id) {
      return this.localProjects.find((p) => p.project_id === id)
    },

    findLocalProjectIndex(id) {
      return this.localProjects.findIndex(p => p.project_id === id)
    },

    removeLocalProjects(project_id) {
      this.localProjects = this.localProjects.filter(
        (project) => project.project_id !== project_id
      );
    },
  },
}
